import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ContentOperationsFragment: GraphQLTaggedNode = graphql`
	fragment ContentOperationsFragment on Content {
		id
		type
		operations {
			operation
			targetType
		}
	}
`;
